import React from 'react';
import styled from '@emotion/styled';

const RadioButtonStyles = styled.div<{ border?: string, height?: string, width?: string }>`
  background: #ffffff;
  border-radius: 50%;
  width: ${props => (props.width)};
  height: ${props => (props.height)};
  border: ${props => (props.border)};
  :hover {
    background-color: #f5f5f5;
  }
`;

interface Props {
  text: string;
  selected: boolean;
  setSelected: (selected: string) => void
}

const RadioButton = (props: Props) => {
  return (
    <>
      <RadioButtonStyles
        onClick={() => (props.setSelected(props.text))}
        border={props.selected ? '8px solid #93918F' : '2px solid #93918F'}
        width={props.selected ? '6px' : '18px'}
        height={props.selected ? '6px' : '18px'}
      />
      <span style={{ marginLeft: 8 }}>{props.text}</span>
    </>
  );
};

export default RadioButton;
